import React, {useEffect} from "react";
import {
    AppBar,
    Paper,
    Container,
    Box,
    CssBaseline,
    Toolbar,
    Typography, Alert
} from "@mui/material";

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import {logout} from "../../features/users/Users";
import {Link, NavLink, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Logo from "../Logo";

const pages = [
    {
        name: 'Feeds',
        route: '/spin/list',
        admin: false
    },

];

const settings = [
    { name: 'Logout', route: '/logout' }
];

function MainLayoutDemand({children, title}) {
    const userName = useSelector((state) => state.users.name);
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <React.Fragment>
            <AppBar position="static" >
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/* Logo and Title */}
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                mr: 2,
                                display: {xs: 'none', md: 'flex'},
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            <Link to='/' style={{color: 'white', textDecoration: "none"}}>
                                <Logo/>
                            </Link>
                        </Typography>

                        {/* Mobile Menu Icon */}
                        <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon/>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    display: {xs: 'block', md: 'none'},
                                }}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                                        <NavLink
                                            to={page.route}
                                            style={({isActive}) =>
                                                isActive
                                                    ? {color: 'black', textDecoration: "none", fontWeight: "bolder"}
                                                    : {color: 'black', textDecoration: "none"}
                                            }
                                        >
                                            {page.name}
                                        </NavLink>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        {/* Desktop Links */}
                        <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    onClick={handleCloseNavMenu}
                                    sx={{my: 2, color: 'white', display: 'block'}}
                                >
                                    <NavLink
                                        to={page.route}
                                        style={({isActive}) =>
                                            isActive
                                                ? {color: 'white', textDecoration: "none", fontWeight: "bolder"}
                                                : {color: 'white', textDecoration: "none"}
                                        }
                                    >
                                        {page.name}
                                    </NavLink>
                                </Button>
                            ))}
                        </Box>

                        {/* User Menu with Logout */}
                        <Box sx={{flexGrow: 0}}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                    <Avatar alt={userName} src="#"/>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{mt: '45px'}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem key="logout" onClick={logout}>
                                    <Typography
                                        style={{
                                            color: 'black',
                                            textDecoration: 'none',
                                            display: 'block',
                                            width: '100%',
                                        }}
                                    >
                                        Logout
                                    </Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
                    minHeight: '100vh',
                    overflow: 'auto',
                    pb: 6 // Add bottom padding to the main area
                }}
            >
                {/* Add a Container with proper padding and max width */}
                <Container 
                    maxWidth="xl" 
                    sx={{ 
                        pt: 4, // Padding top
                        px: { xs: 2, sm: 3, md: 4 }, // Responsive horizontal padding
                    }}
                >
                    {children}
                </Container>
            </Box>
        </React.Fragment>
    );
}

export default MainLayoutDemand;